










import {Component, Vue} from "vue-property-decorator";

@Component
export default class HpSubTitle extends Vue {
  name = "HpSubTitle"
}
